import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslate, Edit, TextInput, SimpleForm } from "react-admin";
import * as yup from "yup";
import CustomHeaderActions from "./CustomHeaderActions";
import ShowAndEditDetails from "./ShowAndEditDetails";
import { AppointmentDetailsIcon } from "assets/Icons";

export default function AppointmentEdit() {
  const translate = useTranslate();

  return (
    <Edit actions={<CustomHeaderActions title="Appointment" />}>
      <SimpleForm resolver={yupResolver(validationSchema)}>
        <ShowAndEditDetails
          title="Appointment details"
          view="edit"
          icon={<AppointmentDetailsIcon />}
        />
        <TextInput
          source="notes"
          label={translate("appointment.notes")}
          fullWidth
          multiline
        />
      </SimpleForm>
    </Edit>
  );
}

const validationSchema = yup
  .object()
  .shape({
    notes: yup.string().nullable()
  })
  .required();
